<template>
  <div
    id="live-grocery"
    class="page-content"
  >
    <div class="row">
      <div class="col-12">
        <pending-grocery-need-love />
        <unpaid-grocery-orders />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, nextTick, defineAsyncComponent } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';

const PendingGroceryNeedLove = defineAsyncComponent(() => import('./Grocery/PendingGroceryNeedLove.vue') as any);
const UnpaidGroceryOrders = defineAsyncComponent(() => import('./Grocery/UnpaidGroceryOrders.vue') as any);

onMounted(async () => {
  const route = useRoute();
  await nextTick();
  util.moveScrollComponent(route.hash);
});
</script>
